import React from 'react';
import { UpDownAnimationI } from './interface';
import { UpDownAnimationContainer } from './style';

const UpDownAnimation: React.FC<UpDownAnimationI> = ({ children, ...props }) => {
  return <UpDownAnimationContainer {...props}>{children}</UpDownAnimationContainer>;
};

export default UpDownAnimation;
